const Services=()=>{
    return(
        <>
        <br></br><br></br><br></br><br></br><br></br>
        <section id="services" className="services-mf pt-5 route">
      <div className="container ">
        <div className="row">
          <div className="col-sm-12">
            <div className="title-box text-center">
              <h3 className="title-a">
                Services
              </h3>
              <p className="subtitle-a">
              </p>
              <div className="line-mf"></div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
              <span className="ico-circle"><i className="bi bi-bar-chart"></i></span>
              </div>
              <div className="service-content ">
                <h1 className="s-title">Responsive Web Design</h1>
                <h5 className="s-description text-center"><br></br>
                  I can create responsive and single page static websites.
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
                <span className="ico-circle"><i className="bi bi-card-checklist"></i></span>
              </div>
              <div className="service-content ">
                <h1 className="s-title">Responsive Web Application Development</h1>
                <h5 className="s-description text-center "><br></br>
                I can create responsive and single page dynamic web applications.
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
              <span className="ico-circle"><i className="bi bi-calendar4-week"></i></span>
              </div>
              <div className="service-content">
                <h1 className="s-title">Desktop Application Development</h1>
                <h5 className="s-description text-center">
                <br></br>
                I can create desktop applications.
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
              <span class="ico-circle"><i class="bi bi-briefcase"></i></span>
              </div>
              <div className="service-content">
                <h1 className="s-title">Software Support</h1>
                <h5 className="s-description text-center"><br></br>
                I provide support for software that i have delivered.
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
                <span className="ico-circle"><i className="bi bi-brightness-high"></i></span>
              </div>
              <div className="service-content ">
                <h1 className="s-title">Graphic Design</h1>
                <h5 className="s-description text-center"><br></br>
                I can design graphics.
                </h5>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="service-box">
              <div className="service-ico">
                <span className="ico-circle"><i className="bi bi-calendar4-week"></i></span>
              </div>
              <div className="service-content ">
                <h1 className="s-title">Marketing Services</h1>
                <h5 className="s-description text-center"><br></br>
                  I provide marketing services.
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        </>
    );
}
export default Services;